<template>
  <div>
    <el-dialog
      :title="isCreate ? '新增白名单项' : '修改白名单项'"
      center
      :visible="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="true"
      :before-close="onClose"
      width="400px"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="50px"
        size="mini"
      >
        <el-form-item label="类型">
          <el-select
            v-model="form.type"
            placeholder="请选择"
            style="width: 130px"
          >
            <el-option
              v-for="item in typeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="值">
          <el-input v-model="form.value" clearable style="width: 130px"></el-input>
          <a
            v-if="form.type == 'ip'"
            @click="inputCuttentIp"
            style="margin-left: 0px; text-decoration: none; font-size: small"
            href="javascript:;"
            >（填入本设备所在网络的IP）</a
          >
        </el-form-item>

        <el-form-item label="备注">
          <el-input v-model="form.remark" type="textarea" rows="3"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onClose">取消</el-button>
        <el-button type="primary" @click="submit()" style="margin-left: 30px"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";
const dialogutil = require("@/dialogutil");

// 本弹窗名称
const DialogName = "EditZoneWhiteDialog";

export default {
  data() {
    return {
      typeOptions: [
        {
          value: "aid",
          label: "aid",
        },
        {
          value: "uid",
          label: "uid",
        },        
        {
          value: "ip",
          label: "ip",
        },
      ],
      rules: {},
      isCreate: false,
      form: {
        type: "aid",
        id: "",
        value: "",
        remark: "",
      },
    };
  },
  components: {},

  created() {
    let paramsFromOutside = dialogutil.getData(DialogName);

    if (!paramsFromOutside) {
      return;
    }

    this.isCreate = paramsFromOutside.isCreate;

    if (paramsFromOutside.isCreate) {
      this.form = { type: "aid", value: "" };
    } else {
      this.form = {
        type: paramsFromOutside.form.type,
        id: paramsFromOutside.form.id,
        remark: paramsFromOutside.form.remark,
        value: paramsFromOutside.form.value,
      };
    }
  },

  methods: {
    /**
     * 提交表单
     */
    submit() {
      if (this.isCreate) {
        this.create();
      } else {
        this.update();
      }
    },

    /**
     * 修改
     */
    async update() {
      try {
        // 弹确认框
        await this.$confirm(`确认修改白名单？`);

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/updateWhiteListEntryForZoneVisit`,
            this.form,
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "修改成功",
          type: "success",
        });

        // 关闭当前对话框
        this.onClose(null);
      } catch (e) {}
    },

    /**
     * 新增
     */
    async create() {
      try {
        // 弹确认框
        await this.$confirm(`确认新增白名单项？`);

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/addWhiteListEntryForZoneVisit`,
            this.form,
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "新增成功",
          type: "success",
        });

        // 关闭当前对话框
        this.onClose(null);
      } catch (e) {}
    },

    onClose(done) {
      // 关闭当前对话框
      dialogutil.close(DialogName);
    },

    async inputCuttentIp() {
      var resData = (await axios.get(`https://api.ipify.org/?format=json`, {}))
        .data;

      this.form.value = resData.ip;
    },
  },
};
</script>